import handleDarkMode from "./composed/handleDarkMode.js";
import jarallaxjs from "./composed/jarallaxjs.js";
import headerscroll from "./composed/headerscroll.js";
import uikitcomponents from "./composed/uikitcomponents.js";
import animatedtext from "./composed/gsapfunctions.js";
import lazyLoadImages from "./composed/lazyimages.js";

document.addEventListener("DOMContentLoaded", firstLoadInit);

function genericInit() {
    headerscroll.init();
    handleDarkMode.init();
    jarallaxjs.init();
    animatedtext.init();
    uikitcomponents.init();
    lazyLoadImages.init();
    markEmptyParagraphs();
    if (window.location.href.includes('Search=')) {
        document.body.classList.remove('SolidMenu');
    }
    if (window.location.href.includes('/blog/category/')) {
        document.body.classList.add('hidefilters');
    }
}

function firstLoadInit() {
    genericInit();
}

function markEmptyParagraphs() {
    var paragraphs = document.getElementsByTagName('p');
    for (var i = 0; i < paragraphs.length; i++) {
        if (paragraphs[i].innerHTML.trim() === '&nbsp;' || paragraphs[i].innerHTML.trim() === '') {
            paragraphs[i].classList.add('hidden');
        }
    }
}
